import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import Button, { ButtonGroup } from 'components/buttons/Button';

import { Loader } from '../../../../components/Loader/Loader';
import { isToday } from 'utils/date';

import '../Widget.scss';
import './DeviationWidget.scss';
import Fetch from '../../../../utils/fetch';
import { settings } from '../../../../settings';

type DeviationsWidget2Props = {
  title: string;
  authorRoles: string;
};

export default function DeviationsWidget2(props: DeviationsWidget2Props) {
  const [isLoading, setIsLoading] = useState(true);
  const [orders, setOrders] = useState<number[]>([]);

  const [filterDay, setFilterDay] = useState<number>(0);
  const selectedDay = dayjs().add(filterDay, 'day').format('YYYY-MM-DD');

  useEffect(() => {
    const fetchProblemOrders = async () => {
      try {
        const response = await Fetch.get({
          url: `${settings.newApiUrl}/deviation/v2/problem-orders/${selectedDay}?authorRoles=${props.authorRoles}`,
        });
        const orderList: number[] = response.ok ? await response.json() : [];
        setOrders(orderList);
      } catch (e) {
        console.warn('Error fetching orders', e);
        setOrders([]);
      }
      setIsLoading(false);
    };
    fetchProblemOrders();
  }, [selectedDay, props.authorRoles]);

  if (isLoading) {
    return (
      <div className="widget">
        <div className="widget__header">
          <h5>Courier Deviations today </h5>
        </div>
        <div className="widget__loader">
          <Loader type="spinner" size="large" />
        </div>
      </div>
    );
  }

  const changeDay = (changeInt: number) => {
    setFilterDay(filterDay + changeInt);
  };

  return (
    <div className="widget">
      <div className="widget__header">
        <h5>{props.title}</h5>
        <span>(new deviation model)</span>
      </div>

      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <div className="problem-box">
          <div className="list-order">
            {orders.map((item, index) => (
              <span key={index}>
                <Link
                  className="problem-order-id"
                  to={{ pathname: `/orders/${item}` }}
                >
                  {item}
                </Link>
                {index < orders.length - 1 && <span>,&nbsp;</span>}
              </span>
            ))}
          </div>
        </div>
      </div>

      <div style={{ height: 10 }} />

      <ButtonGroup>
        <Button title="<" onClick={() => changeDay(-1)} />
        <Button
          style={{ width: '100%' }}
          title={dayjs(selectedDay, 'YYYY-MM-DD').format('dddd DD MMMM')}
        />
        <Button
          title=">"
          onClick={() => changeDay(+1)}
          disabled={isToday(selectedDay)}
        />
      </ButtonGroup>
    </div>
  );
}
